import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { SESSION_TOKEN_KEY } from '@shared/constants/api-headers.constants';
import { lastValueFrom } from 'rxjs';

export interface SessionTokenResponse {
    sessionToken: string;
}

@Injectable({
    providedIn: 'root'
})
export class SecurityService {
    private readonly _httpClient = inject(HttpClient);
    private readonly _apiUrl = `${environment.API_URL_BASE}security`;

    /**
     * Fetches the session token from the security API and persists it in sessionStorage.
     * Must be called once after a successful login, before any other API calls.
     * Subsequent calls are no-ops if a token is already stored.
     */
    async storeSessionToken(): Promise<void> {
        if (sessionStorage.getItem(SESSION_TOKEN_KEY)) return;
        const result = await lastValueFrom(this._httpClient.get<SessionTokenResponse>(`${this._apiUrl}/session`));
        sessionStorage.setItem(SESSION_TOKEN_KEY, result.sessionToken);
    }

    async getSessionToken(): Promise<string> {
        const result = await lastValueFrom(this._httpClient.get<SessionTokenResponse>(`${this._apiUrl}/session`));
        return result.sessionToken;
    }

    async logout(): Promise<void> {
        if (!sessionStorage.getItem(SESSION_TOKEN_KEY)) return;
        
        await lastValueFrom(this._httpClient.post(`${this._apiUrl}/logout`, {}));
        sessionStorage.removeItem(SESSION_TOKEN_KEY);
    }
}